var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z M2 2 C2 11.24 2 20.48 2 30 C11.24 30 20.48 30 30 30 C30 20.76 30 11.52 30 2 C20.76 2 11.52 2 2 2 Z ",
    fill: "#D5D7DB",
    transform: "translate(2,2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.09677419 5.96774194 12.09677419 5.96774194 15 8 C15 8.66 15 9.32 15 10 C12.6889639 11.33592797 10.37628245 12.66884431 8.0625 14 C7.40314453 14.3815625 6.74378906 14.763125 6.06445312 15.15625 C1.11328125 18 1.11328125 18 0 18 C0 12.06 0 6.12 0 0 Z M2 4 C2 7.3 2 10.6 2 14 C4.64 12.68 7.28 11.36 10 10 C10 9.34 10 8.68 10 8 C7.36 6.68 4.72 5.36 2 4 Z ",
    fill: "#D5D6DA",
    transform: "translate(12,9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.2263b9e3f95956c6ddc0554fb8f78dab.svg";
export { ForwardRef as ReactComponent };